import { useAuth, useUser } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router-dom";

import { tenantContext } from "../lib/tenant";

/**
 * Apex safety net: signed-in users with no Clerk org yet must finish
 * `/signup/company` (domain + company names). Catches OAuth misroutes
 * that land on the console SPA outside `/signup/*`.
 */
export function ApexSignupResume() {
  const { isLoaded, isSignedIn } = useAuth();
  const { isLoaded: userLoaded, user } = useUser();
  const location = useLocation();

  if (!isLoaded || !userLoaded) return null;
  if (tenantContext().slug !== null) return null;
  if (!isSignedIn || !user) return null;
  if (
    location.pathname.startsWith("/signup") ||
    location.pathname.startsWith("/signin")
  ) {
    return null;
  }

  const hasOrg = (user.organizationMemberships?.length ?? 0) > 0;
  if (!hasOrg) {
    return <Navigate to="/signup/company" replace />;
  }

  return null;
}
